import { get } from "jquery";
import { defineStore } from "pinia";
// import { useGlobals } from "@/main";

export const usePurchaseOrderStore = defineStore("purchaseOrderStore", {
  state: () => ({
    compRefreshKeys: {
      keyPurchasePanel: 0,
      keyPurchaseDetailConfirmationPanel: 0,
      keyPurchaseApprovalPanel: 0,
    },
    purchaseRequest: {},
    isShowFields: {
      // başka alanlar da yönetilebilir
      projectNumber: null,
    },
    isCreatePO: false,
    queryToPr: null,
    createPOPriceChange: [],
    createPORequiredFields: {},
    // purchaseItem: {
    //   Name: "",
    //   Code: "",
    //   CurrencyCode: "",
    //   Quantity: "",
    //   UnitPrice: "",
    //   TotalAmount: "",
    //   MeasureType: "",
    //   Supplier: "",
    //   CostCentre: "",
    // },
  }),
  getters: {
    getKeyPurchasePanel() {
      return this.compRefreshKeys.keyPurchasePanel;
    },
    getPurchaseOrder() {
      return this.purchaseOrder;
    },
    getIsShowFields() {
      return this.isShowFields;
    },
    getKeyPurchaseDetailConfirmationPanel() {
      return this.compRefreshKeys.keyPurchaseDetailConfirmationPanel;
    },
    getKeyPurchaseApprovalPanel() {
      return this.compRefreshKeys.keyPurchaseApprovalPanel;
    },
    getIsCreatePO() {
      return this.isCreatePO;
    },
    getQueryToPr() {
      return this.queryToPr;
    },
    getCreatePOPriceChange() {
      return this.cratePOPriceChange;
    },
    getCreatePORequiredFields() {
      return this.createPORequiredFields;
    },
    // getPurchaseItems() {
    //   return this.purchaseItems;
    // },
    // getPurchaseItem() {
    //   return this.purchaseItem;
    // },
    // getTotalAmountOfPurchaseItems() {
    //   return this.getPurchaseItems.reduce((acc, t) => {
    //     return parseInt(acc) + parseInt(t.TotalAmount);
    //   }, 0);
    // },
  },
  actions: {
    setIncKeyPurchasePanel() {
      this.compRefreshKeys.keyPurchasePanel += 1;
    },
    setPurchaseOrder({ purchaseOrder }) {
      this.purchaseOrder = purchaseOrder;
    },
    setIsShowFields({ projectNumber }) {
      this.isShowFields.projectNumber = projectNumber;
    },
    setIncKeyPurchaseDetailConfirmationPanel() {
      this.compRefreshKeys.keyPurchaseDetailConfirmationPanel += 1;
    },
    setIncKeyPurchaseApprovalPanel() {
      this.compRefreshKeys.keyPurchaseApprovalPanel += 1;
    },
    setIsCreatePO({ isCreatePO }) {
      this.isCreatePO = isCreatePO;
    },
    setQueryToPr({ pr }) {
      this.queryToPr = pr;
    },
    setCreatePOPriceChange(createPOPriceChange) {
      let existingItem = this.createPOPriceChange.find(item => item.pkey === createPOPriceChange.pkey);
  
      if (existingItem) {
        // Eğer zaten varsa, sadece newVal güncellenir
        existingItem.newVal = createPOPriceChange.newVal;
      } else {
        // Yoksa yeni olarak eklenir
        this.createPOPriceChange.push(createPOPriceChange);
      }
    },
    setCreatePORequiredFields(createPoReqField) {
      this.createPORequiredFields = createPoReqField;
    },
    // setAddPurchaseItem(purchaseItem) {
    //   this.purchaseItems.push(purchaseItem);
    // },
  },
});
